import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReportBarGraphSource } from '@ndt/report-output/shared/models/bar-graph-source-report-parameter';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { ReportParameterComponent } from '../report-parameter-list/report-parameter-component';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';

@Component({
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: BarGraphSourceReportParameterComponent }],
    selector: 'ndt-bar-graph-source-report-parameter',
    templateUrl: './bar-graph-source-report-parameter.component.html',
    standalone: false
})
export class BarGraphSourceReportParameterComponent implements OnDestroy, AfterViewInit, ReportParameterComponent {
   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   config: ReportParameterConfig;

   barGraphSource = Object.values(ReportBarGraphSource);

   constructor() {
      this.form = new UntypedFormGroup({
         value: new UntypedFormControl(ReportBarGraphSource.Duration),
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   ngAfterViewInit(): void {
      this.form.controls.isAskParameter?.valueChanges.pipe(delay(0), takeUntil(this.destroyed$)).subscribe(() => {
         this.form.controls.barGraphSource?.updateValueAndValidity();
      });
   }

   barGraphSourceDisplayWith(option: ReportBarGraphSource): string {
      return `${option ?? ''}`;
   }
}
